// import React, { useState, useRef, useEffect } from 'react';
// import logo from '../images/logo_page.png';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useUserAuth } from "../context/UserAuthContext";
// import { analytics } from "../firebase/index";
// import { logEvent } from "firebase/analytics";
// import { signInWithCustomToken } from "firebase/auth";
// import { auth } from "../firebase/index"
// import { FirebaseAuthentication } from "@capacitor-firebase/authentication";
// import { Capacitor } from '@capacitor/core';

// const PopUp = ({ message }) => {
//   return (
//     <div className="physio-not-registered-popup">
//       <div className="physio-not-registered-popup-content">
//         <p>{message}</p>
//       </div>
//     </div>
//   );
// };

// const PhysioNewOTPPage = () => {
//   const navigate = useNavigate();
//   const [otp, setOtp] = useState(new Array(6).fill(""));
//   const [error, setError] = useState("");
//   const { result, setUser, checkPhysioExist, verificationId } = useUserAuth();
//   const { countryCode, mobileNumber } = useParams();
//   const [showWrongOTPPopup, setShowWrongOTPPopup] = useState(false);
//   const [showTimeoutPopup, setshowTimeoutPopup] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const inputRefs = useRef([]);
//   const [resendMessage, setResendMessage] = useState('');

//   const resendOtp = async () => {
//     setIsLoading(true);
//     console.log('Resending OTP to', `+${countryCode}${mobileNumber}`);
//     setError("");
//     try {
//       const fullPhoneNumber = `+${countryCode}${mobileNumber}`;
//       const response = await fetch(`https://twilioverifyotp-284536061530.us-central1.run.app/request-otp`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           phoneNumber: fullPhoneNumber,
//           service: "Wizphys AI",
//           channel: 'sms'
//         })
//       });

//       const data = await response.json();
//       if (data.success) {
//         setResendMessage("OTP Resent successfully!");
//       } else {
//         setError("Failed to resend. Please try again.");
//       }
//     } catch (err) {
//       setError("Network error. Could not resend OTP.");
//     } finally {
//       setIsLoading(false);
//       // setResendMessage('');
//       // setError('');
//     }
//   };

//   // const verifyOtp = async (e) => {
//   //   e.preventDefault();
//   //   setError("");
//   //   if (otp.some(d => d === "") || otp.length !== 6) {
//   //     setError("Please enter valid OTP.");
//   //     return;
//   //   }
//   //   setIsLoading(true);
//   //   try {
//   //     const otpNumber = Number(otp.join(''));
//   //     await result.confirm(otpNumber);
//   //     logEvent(analytics, "py_verify_otp", {
//   //       "Date": new Date().toLocaleString(),
//   //       "encrypted_py_user_name": mobileNumber,
//   //       "py_log": "ongoing",
//   //     });
//   //     const isRegistered = await checkPhysioExist(mobileNumber);
//   //     if (isRegistered === 0) {
//   //       navigate(`/onboarding/${countryCode}/${mobileNumber}`);
//   //     } else {
//   //       navigate("/");
//   //     }
//   //   } catch (err) {
//   //     logEvent(analytics, "py_verify_otp_error", {
//   //       "Date": new Date().toLocaleString(),
//   //       "encrypted_py_user_name": mobileNumber,
//   //       "py_log_error": err.message,
//   //     });
//   //     if (err.message === 'Firebase: Error (auth/invalid-verification-code).') {
//   //       setError('Invalid OTP');
//   //     } else if (err.code === 'invalid-verification-code') {
//   //       setError("Invalid OTP. Please try again.");
//   //     }
//   //   } finally {
//   //     setIsLoading(false);
//   //   }
//   // };


//   const verifyOtp = async (e) => {
//     e.preventDefault();
//     setError("");
//     if (otp.some(d => d === "") || otp.length !== 6) {
//       setError("Please enter valid OTP.");
//       return;
//     }
//     setIsLoading(true);
//     try {
//       const otpNumber = otp.join('');
//       const fullPhoneNumber = `+${countryCode}${mobileNumber}`;
//       console.log('Verifying OTP for', fullPhoneNumber, 'OTP:', otpNumber);

//       const response = await fetch(`https://twilioverifyotp-284536061530.us-central1.run.app/verify-otp`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           phoneNumber: fullPhoneNumber,
//           code: otpNumber,
//           service: 'Wizphys AI',
//         })
//       });

//       const data = await response.json();

//       if (response.ok && data.success) {
//         logEvent(analytics, "py_verify_otp", {
//           "Date": new Date().toLocaleString(),
//           "encrypted_py_user_name": mobileNumber,
//           "py_log": "ongoing",
//         });
//         await signInWithCustomToken(auth, data.firebaseToken);
//         // Continue with your existing registration check logic
//         const isRegistered = await checkPhysioExist(mobileNumber);
//         if (isRegistered === 0) {
//           navigate(`/onboarding/${countryCode}/${mobileNumber}`);
//         } else {
//           navigate("/");
//         }
//       } else {
//         setError(data.message || "Invalid OTP");
//         setShowWrongOTPPopup(true);
//       }
//       // await result.confirm(otpNumber);
//       // logEvent(analytics, "py_verify_otp", {
//       //   "Date": new Date().toLocaleString(),
//       //   "encrypted_py_user_name": mobileNumber,
//       //   "py_log": "ongoing",
//       // });
//       // const isRegistered = await checkPhysioExist(mobileNumber);
//       // if (isRegistered === 0) {
//       //   navigate(`/onboarding/${countryCode}/${mobileNumber}`);
//       // } else {
//       //   navigate("/");
//       // }
//     } catch (err) {
//       logEvent(analytics, "py_verify_otp_error", {
//         "Date": new Date().toLocaleString(),
//         "encrypted_py_user_name": mobileNumber,
//         "py_log_error": err.message,
//       });
//       if (err.message === 'Firebase: Error (auth/invalid-verification-code).') {
//         setError('Invalid OTP');
//       } else if (err.code === 'invalid-verification-code') {
//         setError("Invalid OTP. Please try again.");
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     const closePopupOutside = (event) => {
//       if (!event.target.closest(".physio-not-registered-popup-content")) {
//         setShowWrongOTPPopup(false);
//         setshowTimeoutPopup(false);
//       }
//     };

//     if (showWrongOTPPopup || showTimeoutPopup) {
//       document.addEventListener("click", closePopupOutside);
//     } else {
//       document.removeEventListener("click", closePopupOutside);
//     }

//     return () => {
//       document.removeEventListener("click", closePopupOutside);
//     };
//   }, [showWrongOTPPopup, showTimeoutPopup]);

//   const handleChange = (element, index) => {
//     const value = element.value;
//     if (!isNaN(value) && value.length <= 1) {
//       setOtp([...otp.map((d, idx) => (idx === index ? value : d))]);
//       if (value !== "" && index < 5) {
//         inputRefs.current[index + 1].focus();
//       }
//     }
//   };

//   const handleKeyDown = (e, index) => {
//     if (e.key === "Backspace") {
//       if (otp[index] === "" && index > 0) {
//         inputRefs.current[index - 1].focus();
//       }
//       setOtp([...otp.map((d, idx) => (idx === index ? "" : d))]);
//     }
//   };

//   const handlePaste = (e) => {
//     e.preventDefault();
//     const paste = e.clipboardData.getData("text");
//     if (paste.length === otp.length && /^[0-9]+$/.test(paste)) {
//       const pasteArray = paste.split("").slice(0, otp.length);
//       setOtp(pasteArray);
//       pasteArray.forEach((value, index) => {
//         inputRefs.current[index].value = value;
//       });
//       inputRefs.current[otp.length - 1].focus();
//     }
//   };

//   const allDigitsEntered = otp.every(d => d !== "");

//   return (
//     <div className='newPhysioSignUp'>
//       <div className='content'>
//         <div className='textContainer'>
//           <div style={{ display: "flex" }}>
//             <img src={logo} style={{ height: "50px" }} alt="Logo" />
//             <div style={{ fontWeight: "600", fontSize: "40px" }}>
//               Wizphys.io
//             </div>
//           </div>
//           <div style={{ paddingLeft: "3%", width: "180px", lineHeight: "18px" }}>
//             Everything you need for a speedy recovery
//           </div>
//         </div>
//         <div className="docImageWrapper">
//           <img src='https://firebasestorage.googleapis.com/v0/b/snaiyu-7b192.appspot.com/o/PhysioUIContent%2Fdocimage.png?alt=media&token=18ab9702-e015-4f87-ba5b-8cba69026cc7' alt="OTP Doctor" className="docImage" loading="lazy" />
//         </div>
//       </div>
//       <div className="inputSection">
//         <div className="OTPinputContainer" style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: "24px" }} onPaste={handlePaste}>
//           {otp.map((data, index) => (
//             <input
//               key={index}
//               type="text"
//               inputMode="numeric"
//               value={data}
//               onChange={e => handleChange(e.target, index)}
//               onKeyDown={e => handleKeyDown(e, index)}
//               ref={el => (inputRefs.current[index] = el)}
//               className="new-otp-input"
//             />
//           ))}
//         </div>

//         <div style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "40px" }}>
//           <label htmlFor="terms" style={{ color: '#2D2F35', fontWeight: "500" }}>
//             {error ? (
//               <span style={{ color: 'red', fontWeight: "bold", paddingRight: "8px" }}>{error}</span>
//             ) : resendMessage ? (
//               <span style={{ color: 'green', fontWeight: "bold", paddingRight: "8px" }}>{resendMessage}</span>
//             ) : (
//               "Didn't get OTP?"
//             )}
//           </label>
//           <a onClick={resendOtp} style={{ color: "#E09C5C", fontWeight: "600", textDecoration: "underline", marginLeft: "8px" }}>Resend Now</a>
//         </div>

//         <button className='InputBtn' style={{ width: "100%", backgroundColor: allDigitsEntered ? '#3974E5' : '#8E8A8A' }} onClick={verifyOtp} disabled={!allDigitsEntered}>
//           {isLoading ? 'Loading...' : 'GET STARTED'}
//         </button>
//       </div>

//       {showWrongOTPPopup && <PopUp message="Wrong OTP. Please try again." />}
//       {showTimeoutPopup && <PopUp message="OTP Expired." />}
//     </div>
//   );
// }

// export default PhysioNewOTPPage;


import React, { useState, useRef, useEffect } from 'react';
import logo from '../images/logo_page.png';
import { useParams, useNavigate } from 'react-router-dom';
import { useUserAuth } from "../context/UserAuthContext";
import { analytics } from "../firebase/index";
import { logEvent } from "firebase/analytics";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../firebase/index";
import { Capacitor } from '@capacitor/core';
import { FirebaseAuthentication } from "@capacitor-firebase/authentication";

// ✅ Must match the Set in PhysioNewSignUpPhone.js
const TWILIO_SUPPORTED_CODES = new Set([
  '+966', '+20', '+971', '+965', '+974', '+973', '+968',
  '+44', '+33', '+49', '+1', '+27',
]);

const PopUp = ({ message }) => (
  <div className="physio-not-registered-popup">
    <div className="physio-not-registered-popup-content">
      <p>{message}</p>
    </div>
  </div>
);

const PhysioNewOTPPage = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [error, setError] = useState("");
  const { result, setResult, setUser, checkPhysioExist, verificationId, setUpRecaptcha } = useUserAuth();
  const { countryCode, mobileNumber } = useParams();
  const [showWrongOTPPopup, setShowWrongOTPPopup] = useState(false);
  const [showTimeoutPopup, setShowTimeoutPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const inputRefs = useRef([]);

  // ✅ Derived: which auth method was used to get here
  // If `result` is set in context → Firebase flow. Otherwise → Twilio flow.
  const fullCountryCode = `+${countryCode}`;
  const isTwilioFlow = !result && TWILIO_SUPPORTED_CODES.has(fullCountryCode);

  // ── POST-VERIFY: shared navigation logic ──────────────────────────────────
  const handlePostVerify = async () => {
    logEvent(analytics, "py_verify_otp", {
      Date: new Date().toLocaleString(),
      encrypted_py_user_name: mobileNumber,
      py_log: "ongoing",
    });
    const isRegistered = await checkPhysioExist(mobileNumber);
    if (isRegistered === 0) {
      navigate(`/onboarding/${countryCode}/${mobileNumber}`);
    } else {
      navigate("/");
    }
  };

  // ── TWILIO VERIFY ─────────────────────────────────────────────────────────
  const verifyViaTwilio = async (otpString) => {
    const fullPhoneNumber = `${fullCountryCode}${mobileNumber}`;
    const response = await fetch(
      `https://twilioverifyotp-284536061530.us-central1.run.app/verify-otp`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phoneNumber: fullPhoneNumber,
          code: otpString,
          service: 'Wizphys AI',
        }),
      }
    );
    const data = await response.json();
    if (response.ok && data.success) {
      await signInWithCustomToken(auth, data.firebaseToken);
      await handlePostVerify();
    } else {
      throw new Error(data.message || "Invalid OTP");
    }
  };

  // ── FIREBASE VERIFY ───────────────────────────────────────────────────────
  const verifyViaFirebase = async (otpString) => {
    // if (Capacitor.isNativePlatform()) {
    //   // Native: use FirebaseAuthentication plugin with stored verificationId
    //   await FirebaseAuthentication.confirmVerificationCode({
    //     verificationId,
    //     verificationCode: otpString,
    //   });
    // } else {
      // Web: use the confirmation result stored in context
      await result.confirm(otpString);
    // }
    await handlePostVerify();
  };

  // ── MAIN VERIFY HANDLER ───────────────────────────────────────────────────
  const verifyOtp = async (e) => {
    e.preventDefault();
    setError("");

    if (otp.some(d => d === "") || otp.length !== 6) {
      setError("Please enter a valid OTP.");
      return;
    }

    setIsLoading(true);
    const otpString = otp.join('');

    try {
      if (isTwilioFlow) {
        await verifyViaTwilio(otpString);
      } else {
        await verifyViaFirebase(otpString);
      }
    } catch (err) {
      logEvent(analytics, "py_verify_otp_error", {
        Date: new Date().toLocaleString(),
        encrypted_py_user_name: mobileNumber,
        py_log_error: err.message,
      });

      // Normalize error messages from both Firebase and Twilio
      const msg = err.message || "";
      if (
        msg.includes("auth/invalid-verification-code") ||
        msg.includes("invalid-verification-code") ||
        msg.toLowerCase().includes("invalid otp") ||
        msg.toLowerCase().includes("incorrect")
      ) {
        setError("Invalid OTP. Please try again.");
        setShowWrongOTPPopup(true);
      } else if (msg.includes("auth/code-expired") || msg.toLowerCase().includes("expired")) {
        setError("OTP expired. Please request a new one.");
        setShowTimeoutPopup(true);
      } else {
        setError(err.message || "Something went wrong. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // ── RESEND OTP ────────────────────────────────────────────────────────────
  const resendOtp = async () => {
    setIsLoading(true);
    setError("");
    setResendMessage("");

    try {
      if (isTwilioFlow) {
        // Twilio resend
        const fullPhoneNumber = `${fullCountryCode}${mobileNumber}`;
        const response = await fetch(
          `https://twilioverifyotp-284536061530.us-central1.run.app/request-otp`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              phoneNumber: fullPhoneNumber,
              service: "Wizphys AI",
              channel: 'sms',
            }),
          }
        );
        const data = await response.json();
        if (data.success) {
          setResendMessage("OTP resent successfully!");
        } else {
          setError("Failed to resend. Please try again.");
        }
      } else {
        // Firebase resend — re-run setUpRecaptcha to get a fresh result
        const newResult = await setUpRecaptcha(mobileNumber, fullCountryCode);
        setResult(newResult);
        setResendMessage("OTP resent successfully!");
      }
    } catch (err) {
      console.error("Resend error:", err);
      setError("Network error. Could not resend OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  // ── POPUP CLOSE ON OUTSIDE CLICK ──────────────────────────────────────────
  useEffect(() => {
    const closePopupOutside = (event) => {
      if (!event.target.closest(".physio-not-registered-popup-content")) {
        setShowWrongOTPPopup(false);
        setShowTimeoutPopup(false);
      }
    };
    if (showWrongOTPPopup || showTimeoutPopup) {
      document.addEventListener("click", closePopupOutside);
    }
    return () => document.removeEventListener("click", closePopupOutside);
  }, [showWrongOTPPopup, showTimeoutPopup]);

  // ── INPUT HANDLERS ────────────────────────────────────────────────────────
  const handleChange = (element, index) => {
    const value = element.value;
    if (!isNaN(value) && value.length <= 1) {
      setOtp([...otp.map((d, idx) => (idx === index ? value : d))]);
      if (value !== "" && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        inputRefs.current[index - 1].focus();
      }
      setOtp([...otp.map((d, idx) => (idx === index ? "" : d))]);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text");
    if (paste.length === otp.length && /^[0-9]+$/.test(paste)) {
      const pasteArray = paste.split("").slice(0, otp.length);
      setOtp(pasteArray);
      pasteArray.forEach((value, index) => {
        inputRefs.current[index].value = value;
      });
      inputRefs.current[otp.length - 1].focus();
    }
  };

  const allDigitsEntered = otp.every(d => d !== "");

  return (
    <div className='newPhysioSignUp'>
      <div className='content'>
        <div className='textContainer'>
          <div style={{ display: "flex" }}>
            <img src={logo} style={{ height: "50px" }} alt="Logo" />
            <div style={{ fontWeight: "600", fontSize: "40px" }}>Wizphys.io</div>
          </div>
          <div style={{ paddingLeft: "3%", width: "180px", lineHeight: "18px" }}>
            Everything you need for a speedy recovery
          </div>
        </div>
        <div className="docImageWrapper">
          <img
            src='https://firebasestorage.googleapis.com/v0/b/snaiyu-7b192.appspot.com/o/PhysioUIContent%2Fdocimage.png?alt=media&token=18ab9702-e015-4f87-ba5b-8cba69026cc7'
            alt="OTP Doctor"
            className="docImage"
            loading="lazy"
          />
        </div>
      </div>

      <div className="inputSection">
        {/* ✅ Shows which method is active — helpful during testing, can be removed in prod */}
        {/* <div style={{ textAlign: "center", fontSize: "13px", color: "#888", marginBottom: "8px" }}>
          {isTwilioFlow
            ? `OTP sent via SMS to +${countryCode} ${mobileNumber}`
            : `OTP sent via authenticator to +${countryCode} ${mobileNumber}`}
        </div> */}

        <div
          className="OTPinputContainer"
          style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: "24px" }}
          onPaste={handlePaste}
        >
          {otp.map((data, index) => (
            <input
              key={index}
              type="text"
              inputMode="numeric"
              value={data}
              onChange={e => handleChange(e.target, index)}
              onKeyDown={e => handleKeyDown(e, index)}
              ref={el => (inputRefs.current[index] = el)}
              className="new-otp-input"
            />
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "40px" }}>
          <label style={{ color: '#2D2F35', fontWeight: "500" }}>
            {error ? (
              <span style={{ color: 'red', fontWeight: "bold", paddingRight: "8px" }}>{error}</span>
            ) : resendMessage ? (
              <span style={{ color: 'green', fontWeight: "bold", paddingRight: "8px" }}>{resendMessage}</span>
            ) : (
              "Didn't get OTP?"
            )}
          </label>
          <a
            onClick={resendOtp}
            style={{ color: "#E09C5C", fontWeight: "600", textDecoration: "underline", marginLeft: "8px", cursor: "pointer" }}
          >
            Resend Now
          </a>
        </div>

        <button
          className='InputBtn'
          style={{ width: "100%", backgroundColor: allDigitsEntered ? '#3974E5' : '#8E8A8A' }}
          onClick={verifyOtp}
          disabled={!allDigitsEntered || isLoading}
        >
          {isLoading ? 'Verifying...' : 'GET STARTED'}
        </button>
      </div>

      {showWrongOTPPopup && <PopUp message="Wrong OTP. Please try again." />}
      {showTimeoutPopup && <PopUp message="OTP Expired. Please request a new one." />}
    </div>
  );
};

export default PhysioNewOTPPage;